module.exports = __webpack_public_path__ + "static/media/auto1.1e66101b.avif";